// import React, { useCallback, useMemo } from 'react';
// import { Tabs, Tag, Typography, Space } from 'antd';
// import { useSearchParams } from 'react-router-dom';
// import CrudPage from '../../components/common/CrudPage';
// import roleService from '../../services/roleManagementRequest';
// import permissionService from '../../services/permissionManagementRequest';

// const { Text } = Typography;

// const PERMISSION_STATUS = {
//   ACTIVE: 1,
//   INACTIVE: 0,
// };

// // --- Tab: Quản lý Vai trò ---
// const RoleTab = () => {
//   const roleColumns = [
//     {
//       title: 'TÊN NHÓM QUYỀN',
//       dataIndex: 'name',
//       key: 'name',
//       render: (text) => <Text strong>{text}</Text>,
//     },
//     {
//       title: 'MÔ TẢ',
//       dataIndex: 'description',
//       key: 'description',
//       render: (value) => value || '-',
//     },
//     {
//       title: 'SỐ THÀNH VIÊN',
//       dataIndex: 'total_user',
//       key: 'total_user',
//       align: 'center',
//     },
//     {
//       title: 'NGÀY TẠO',
//       dataIndex: 'created_at',
//       key: 'created_at',
//       render: (value) => value || '-',
//     },
//     {
//       title: 'TRẠNG THÁI',
//       dataIndex: 'status',
//       key: 'status',
//       render: (value) => (
//         <Tag color={value === PERMISSION_STATUS.ACTIVE ? 'green' : 'red'}>
//           {value === PERMISSION_STATUS.ACTIVE ? 'Kích hoạt' : 'Chờ kích hoạt'}
//         </Tag>
//       ),
//     },
//   ];

//   const roleFields = [
//     {
//       name: 'name',
//       label: 'Tên nhóm quyền',
//       rules: [{ required: true }],
//       lg: 24,
//     },
//     {
//       name: 'description',
//       label: 'Mô tả',
//       type: 'textarea',
//       lg: 24,
//     },
//     {
//       name: 'status',
//       label: 'Trạng thái',
//       type: 'select',
//       rules: [{ required: true }],
//       options: [
//         { label: 'Kích hoạt', value: 1 },
//         { label: 'Chờ kích hoạt', value: 0 },
//       ],
//       defaultValue: 1,
//       lg: 24,
//     },
//   ];

//   return (
//     <CrudPage
//       title="QUẢN LÝ VAI TRÒ"
//       subTitle="Quản lý nhóm quyền trong hệ thống"
//       itemsName="Vai trò"
//       queryKey="admin-roles"
//       service={roleService}
//       columns={roleColumns}
//       formFields={roleFields}
//       searchPlaceholder="Tìm kiếm vai trò..."
//       addButtonLabel="Thêm vai trò"
//       disableCopy={true}
//       formConfig={{ width: 600 }}
//     />
//   );
// };

// // --- Tab: Quản lý Tính năng (Permission) ---
// const PermissionTab = () => {
//   const ARRAY_COLOR = ['magenta', 'red', 'volcano', 'orange', 'gold', 'lime'];

//   const permissionColumns = [
//     {
//       title: 'TÊN TÍNH NĂNG',
//       dataIndex: 'name',
//       key: 'name',
//       render: (text) => <Text strong>{text}</Text>,
//     },
//     {
//       title: 'KEY MENU',
//       dataIndex: 'key_menu',
//       key: 'key_menu',
//       render: (text) => <Tag color="blue">{text}</Tag>,
//     },
//     {
//       title: 'URL VIEW',
//       dataIndex: 'url',
//       key: 'url',
//       render: (value) => value || '-',
//     },
//     {
//       title: 'API',
//       dataIndex: 'api',
//       key: 'api',
//       render: (value) => value || '-',
//     },
//     {
//       title: 'ACTIONS',
//       dataIndex: 'actions',
//       key: 'actions',
//       render: (actions) =>
//         actions?.length > 0 ? (
//           <Space direction="vertical" size={4}>
//             {actions.map((item, idx) => (
//               <div className="flex gap-2 items-center" key={idx}>
//                 <Tag color={ARRAY_COLOR[idx % ARRAY_COLOR.length]}>{item.name}</Tag>
//                 <Text type="secondary" className="text-xs">
//                   {item.api}
//                 </Text>
//               </div>
//             ))}
//           </Space>
//         ) : (
//           '-'
//         ),
//     },
//     {
//       title: 'TRẠNG THÁI',
//       dataIndex: 'status',
//       key: 'status',
//       render: (value) => (
//         <Tag color={value === PERMISSION_STATUS.ACTIVE ? 'green' : 'red'}>
//           {value === PERMISSION_STATUS.ACTIVE ? 'Kích hoạt' : 'Chờ kích hoạt'}
//         </Tag>
//       ),
//     },
//   ];

//   const permissionFields = [
//     {
//       name: 'name',
//       label: 'Tên tính năng',
//       rules: [{ required: true }],
//       lg: 24,
//     },
//     {
//       name: 'key_menu',
//       label: 'Key menu',
//       rules: [{ required: true }],
//       lg: 24,
//     },
//     {
//       name: 'url',
//       label: 'Url view',
//       lg: 24,
//     },
//     {
//       name: 'api',
//       label: 'Api',
//       rules: [{ required: true }],
//       lg: 24,
//     },
//     {
//       name: 'status',
//       label: 'Trạng thái',
//       type: 'select',
//       rules: [{ required: true }],
//       options: [
//         { label: 'Hoạt động', value: 1 },
//         { label: 'Không hoạt động', value: 0 },
//       ],
//       defaultValue: 1,
//       lg: 24,
//     },
//     {
//       name: 'actions',
//       label: 'Danh sách action',
//       type: 'group',
//       lg: 24,
//       titleButtonAdd: 'Thêm action',
//       classItem: 'flex items-center gap-1 w-full',
//       rowClass: 'border border-gray-200 rounded-lg !py-1 !px-2',
//       filedsList: [
//         {
//           name: 'enabled',
//           type: 'checkbox',
//           defaultChecked: true,
//           span: 2,
//           md: 2,
//           lg: 2,
//           colClass: 'flex items-center justify-center !mb-0',
//         },
//         {
//           name: 'name',
//           placeholder: 'Tên action',
//           rules: [{ required: true }],
//           span: 6,
//           md: 6,
//           lg: 6,
//           colClass: '!mb-0',
//         },
//         {
//           name: 'api',
//           placeholder: 'API path',
//           rules: [{ required: true }],
//           span: 16,
//           md: 16,
//           lg: 16,
//           colClass: '!mb-0',
//         },
//       ],
//     },
//   ];

//   // Convert enabled: 1/0 → true/false cho checkbox hoạt động đúng
//   const mapDataToForm = useCallback((record) => ({
//     actions: record.actions?.map((action) => ({
//       ...action,
//       enabled: !!action.enabled,
//     })),
//   }), []);

//   return (
//     <CrudPage
//       title="QUẢN LÝ TÍNH NĂNG"
//       subTitle="Quản lý permissions trong hệ thống"
//       itemsName="Tính năng"
//       queryKey="admin-permissions"
//       service={permissionService}
//       columns={permissionColumns}
//       formFields={permissionFields}
//       searchPlaceholder="Tìm kiếm tính năng..."
//       addButtonLabel="Thêm tính năng"
//       formConfig={{ width: 700 }}
//       mapDataToForm={mapDataToForm}
//     />
//   );
// };

// // --- Trang chính ---
// const RoleManagement = () => {
//   const [, setSearchParams] = useSearchParams();

//   const handleTabChange = useCallback(() => {
//     // Xoá params URL khi đổi tab để tránh ảnh hưởng lẫn nhau
//     setSearchParams({});
//   }, [setSearchParams]);

//   const tabItems = useMemo(
//     () => [
//       {
//         key: 'roles',
//         label: 'Vai trò',
//         children: <RoleTab />,
//       },
//       {
//         key: 'permissions',
//         label: 'Tính năng',
//         children: <PermissionTab />,
//       },
//     ],
//     []
//   );

//   return (
//     <div className="w-full">
//       <Tabs defaultActiveKey="roles" type="card" items={tabItems} onChange={handleTabChange} />
//     </div>
//   );
// };

// export default RoleManagement;


import React, { useContext, useEffect, useRef, useState } from 'react';
import Tree from 'react-d3-tree';
import { Space, Tabs, Typography } from 'antd';
import PureSvgNodeElement from '../../components/tree-3d/PureSvgNodeElement';
import { useQuery } from '@tanstack/react-query';
import permissionService, { getListPermissionRequest } from '../../services/permissionManagementRequest';
import { RoleContext } from '../../hooks/context/RoleContext';
import RoleTable from '../../components/table/RoleTable';
import roleService from '../../services/roleManagementRequest';
import PermissionTable from '../../components/table/PermissionTable';

const ViewTable = () => {
  return (
    <>
      <Space direction={'vertical'} className={'w-full'} size={30}>
        <RoleTable />
        <PermissionTable />
      </Space>
    </>
  );
};
const ViewTree = () => {
  const ref = useRef();
  const [translate, setTranslate] = useState(null);
  const [dataChart, setDataChart] = useState({
    name: 'ADMIN',
    children: [],
  });
  const {
    rolesQuery: { data: rawRoles },
    permissionQuery: { data: rawPermission },
  } = useContext(RoleContext);
  // Extract array safe từ response
  const dataRoles = Array.isArray(rawRoles) ? rawRoles : rawRoles?.data || rawRoles?.rows || [];
  const dataPermission = Array.isArray(rawPermission) ? rawPermission : rawPermission?.data || rawPermission?.rows || [];

  useEffect(() => {
    if (ref.current) {
      setTranslate({ x: ref.current.clientWidth / 2, y: 40 });
    }
  }, [ref]);

  useEffect(() => {
    if (dataRoles.length && dataPermission.length) {
      let data = [];
      for (let role of dataRoles) {
        let dataRole = {
          name: role.name,
          children: dataPermission
            .filter((item) => role.permission_ids.includes(item.id))
            .map((item) => {
              return {
                name: item.name,
                children: [
                  { name: 'View' },
                  ...item.actions.filter((i) => role.permission_ids.includes(i.id)).map((i) => ({ name: i.name })),
                ],
              };
            }),
        };
        data.push(dataRole);
      }
      setDataChart((prevState) => ({ ...prevState, children: data }));
    }
  }, [dataRoles, dataPermission]);

  const orgChart = {
    name: 'ADMIN',
    children: [
      {
        name: 'Seller',
        children: [
          { name: 'Đơn hàng', children: [{ name: 'Thêm' }, { name: 'Sửa' }, { name: 'Xoá' }, { name: 'Xem' }] },
          { name: 'Đặt lịch tư vấn', children: [{ name: 'Thêm' }, { name: 'Sửa' }, { name: 'Xoá' }, { name: 'Xem' }] },
        ],
      },
      {
        name: 'Tester',
        children: [
          { name: 'Đơn hàng', children: [{ name: 'Thêm' }, { name: 'Sửa' }, { name: 'Xoá' }, { name: 'Xem' }] },
          { name: 'Đặt lịch tư vấn', children: [{ name: 'Thêm' }, { name: 'Sửa' }, { name: 'Xoá' }, { name: 'Xem' }] },
          { name: 'Mẫu đặt lịch', children: [{ name: 'Thêm' }, { name: 'Sửa' }, { name: 'Xoá' }, { name: 'Xem' }] },
        ],
      },
      {
        name: 'Develop',
        children: [
          { name: 'Đơn hàng', children: [{ name: 'Thêm' }, { name: 'Sửa' }, { name: 'Xoá' }, { name: 'Xem' }] },
          { name: 'Đặt lịch tư vấn', children: [{ name: 'Thêm' }, { name: 'Sửa' }, { name: 'Xoá' }, { name: 'Xem' }] },
        ],
      },
      {
        name: 'Experts',
        children: [
          {
            name: 'Lịch làm việc chuyên gia',
            children: [{ name: 'Thêm' }, { name: 'Sửa' }, { name: 'Xoá' }, { name: 'Xem' }],
          },
          { name: 'Đặt lịch tư vấn', children: [{ name: 'Thêm' }, { name: 'Sửa' }, { name: 'Xoá' }, { name: 'Xem' }] },
        ],
      },
    ],
  };
  return (
    <>
      <div id="treeWrapper" style={{ height: 'calc(100vh - 200px)' }} className={'w-full'} ref={ref}>
        {translate && (
          <Tree
            data={dataChart}
            orientation={'vertical'} // mode horizontal or vertical
            zoomable={true} // enable zoom
            zoom={0.69} // default zoom
            translate={translate} // default translate center or {x, y}
            separation={{ nonSiblings: 1.5, siblings: 1 }} // khoang cach giua cac element  depth * number
            draggable={true} // kéo thả di chuyển
            nodeSize={{ x: 80, y: 180 }}
            collapsible={false} // click để mở rộng hoặc ẩn bớt
            // initialDepth={5} // default show
            depthFactor={300} // do dai duong noi parent vs children
            renderCustomNodeElement={(rd3tProps) => {
              // custom render text
              return (
                <PureSvgNodeElement
                  nodeDatum={rd3tProps.nodeDatum}
                  toggleNode={rd3tProps.toggleNode}
                  orientation={'vertical'}
                  depth={rd3tProps.hierarchyPointNode.depth}
                />
              );
            }}
          />
        )}
      </div>
    </>
  );
};

const RoleManagement = () => {
  const rolesQuery = useQuery({ queryKey: ['list-roles'], queryFn: () => roleService.getList() });
  const permissionQuery = useQuery({ queryKey: ['list-permission'], queryFn: () => permissionService.getList({ limit: 9999 }) });

  return (
    <>
      <div className={'w-full'}>
        <Typography.Title level={4} className={'uppercase text-center'}>
          phân quyền admin
        </Typography.Title>
        <RoleContext.Provider value={{ rolesQuery, permissionQuery }}>
          <Tabs
            defaultActiveKey="1"
            type="card"
            items={[
              {
                key: 1,
                label: 'Bảng',
                children: <ViewTable />,
              },
              {
                key: 2,
                label: 'Sơ đồ',
                children: <ViewTree />,
              },
            ]}
          />
        </RoleContext.Provider>
      </div>
    </>
  );
};

export default RoleManagement;
